module.exports = __webpack_public_path__ + "fonts/AkkuratLL-Light.45670754.otf";